import { useEffect, useState } from 'react'

import {
  SHORTCUT_BINDINGS_UPDATED_EVENT,
  loadShortcutBindings,
  type ShortcutBindings,
} from 'utils/shortcutBindings'

/**
 * The user's current shortcut bindings, kept live.
 *
 * Every surface that PRINTS a binding needs this rather than a one-off read: the
 * settings card can change a binding while the sidebar is on screen behind it, and
 * a hint that still advertises the old chord is worse than no hint at all.
 *
 * Two listeners, because they cover different cases and neither covers both:
 *   • the custom event fires in the tab that wrote — `storage` deliberately does not.
 *   • `storage` fires in the OTHER tabs, which the custom event cannot reach.
 */
export const useShortcutBindings = (): ShortcutBindings => {
  const [bindings, setBindings] = useState<ShortcutBindings>(loadShortcutBindings)

  useEffect(() => {
    const sync = () => setBindings(loadShortcutBindings())

    window.addEventListener(SHORTCUT_BINDINGS_UPDATED_EVENT, sync)
    window.addEventListener('storage', sync)

    return () => {
      window.removeEventListener(SHORTCUT_BINDINGS_UPDATED_EVENT, sync)
      window.removeEventListener('storage', sync)
    }
  }, [])

  return bindings
}
